import React from 'react';
import { Lists, HeaderSwiper } from '@/components/mixins'
import '../../common/common.scss'
class Information extends React.PureComponent {
  constructor() {
    super()
    this.state = {
      headerDataLists: [
        { imgPath: require("img/EcosphereDetails/Informationbanner.png"), imgHDPath: `${require("img/EcosphereDetails/Informationbanner.png")} 1x,${require("img/EcosphereDetails/Informationbanner@2x.png")} 2x,${require("img/EcosphereDetails/Informationbanner@3x.png")} 3x`, attachURL: "/" }
      ],
      dataLists: [
        {
          title: '建设工程大数据整体解决方案',
          data: '青矩为建设工程行业提供全过程工程数据治理和应用的整体解决方案。建设工程项目规模大、周期 长、参与方多、流程复杂、综合管理难度高，青矩提供了以数据为抓手，以数据挖掘和智能应用为手段，实现建设工程项目体系化、精细化管理的新思路。',
          imgPath: require("img/EcosphereDetails/Informationicon01.png"), imgHDPath: `${require("img/EcosphereDetails/Informationicon01.png")} 1x,${require("img/EcosphereDetails/Informationicon01@2x.png")} 2x,${require("img/EcosphereDetails/Informationicon01@3x.png")} 3x`
        },
        {
          title: '建设工程大数据平台',
          data: '青矩为企业提供建设工程大数据平台建设服务。平台基于大数据、RPA、NLP、机器学习等IT 技术，实现全过程工程数据的采集、清洗和结构化存储，建立项目指标体系和项目动态画像，开发满足工程各阶段需求的数据智能应用工具，支持高质高效的项目管理，达成降本增效的目标，实现企业的数字化转型升级。',
          imgPath: require("img/EcosphereDetails/Informationicon02.png"), imgHDPath: `${require("img/EcosphereDetails/Informationicon03.png")} 1x,${require("img/EcosphereDetails/Informationicon03@2x.png")} 2x,${require("img/EcosphereDetails/Informationicon03@3x.png")} 3x`
        },
        // {
        //   title: '工程大数据服务平台',
        //   data: '以工程大数据中台体系为理论基础，研发工程大数据服务平台。平台面向行业开放，支持项目、单项工程、指标等基础数据管理，提供数据智能应用服务和工具，以大数据技术、NLP技术、机器学习技术为手段，提升行业生产效率和质量，助力传统行业的数字化转型。',
        //   imgPath: require("img/EcosphereDetails/Informationicon03.png"), imgHDPath: `${require("img/EcosphereDetails/Informationicon03.png")} 1x,${require("img/EcosphereDetails/Informationicon03@2x.png")} 2x,${require("img/EcosphereDetails/Informationicon03@3x.png")} 3x`
        // }
      ],
    }
  }
  render() {
    return (
      <main>
        <HeaderSwiper headerDataLists={this.state.headerDataLists}></HeaderSwiper>
        <div className="Information">
          <h5 className='product-title'>服务介绍</h5>
          <Lists dataLists={this.state.dataLists}></Lists>
        </div>
      </main>
    )
  }
}
export default Information
